// Backend API base for the inoneyear worker (phase 2).
// Local dev: wrangler dev on :8787. Production: same origin (deployed together).
// 本地开发常见三种主机名：localhost / 127.0.0.1 / [::1]（IPv6 回环）
const isLocal =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
export const API = isLocal ? "http://localhost:8787" : "";
